import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createRouter, createWebHistory } from 'vue-router'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-sugar.css'

import App from './App.vue'
import pusher from './lib/pusher'
import { isAuthenticated, getAdminRole } from './lib/auth'

import PublicLayout from './layouts/PublicLayout.vue'
import EventoPage from './pages/public/EventoPage.vue'
import CheckoutPage from './pages/public/CheckoutPage.vue'
import SucessoPage from './pages/public/SucessoPage.vue'
import NotFoundPage from './pages/public/NotFoundPage.vue'

import AdminLayout from './layouts/AdminLayout.vue'
import LoginPage from './pages/admin/LoginPage.vue'
import DashboardPage from './pages/admin/DashboardPage.vue'
import EventosPage from './pages/admin/EventosPage.vue'
import InscricoesPage from './pages/admin/InscricoesPage.vue'
import UsuariosPage from './pages/admin/UsuariosPage.vue'
import RepassesPage from './pages/admin/RepassesPage.vue'
import SaquesPage from './pages/admin/SaquesPage.vue'
import CobrancasPage from './pages/admin/CobrancasPage.vue'
import CheckinPage from './pages/admin/CheckinPage.vue'
import ScanPage from './pages/public/ScanPage.vue'
import MeuQrPage from './pages/public/MeuQrPage.vue'

const routes = [
  {
    path: '/admin/login',
    name: 'Login',
    component: LoginPage,
    meta: { public: true }
  },
  {
    path: '/admin',
    component: AdminLayout,
    children: [
      { path: '', name: 'AdminDashboard', component: DashboardPage },
      { path: 'eventos', name: 'AdminEventos', component: EventosPage },
      { path: 'inscricoes', name: 'AdminInscricoes', component: InscricoesPage },
      { path: 'cobrancas', name: 'AdminCobrancas', component: CobrancasPage, meta: { roles: ['ROOT', 'ADMIN', 'ORGANIZADOR'] } },
      { path: 'repasses', name: 'AdminRepasses', component: RepassesPage, meta: { roles: ['ROOT', 'ADMIN'] } },
      { path: 'saques', name: 'AdminSaques', component: SaquesPage, meta: { roles: ['ROOT', 'ADMIN', 'ORGANIZADOR'] } },
      { path: 'checkin', name: 'AdminCheckin', component: CheckinPage, meta: { roles: ['ROOT', 'ADMIN', 'CHECKIN'] } },
      { path: 'usuarios', name: 'AdminUsuarios', component: UsuariosPage, meta: { roles: ['ROOT', 'ADMIN'] } }
    ]
  },
  {
    path: '/revival-2k26',
    name: 'EventoRevival2k26',
    component: () => import('./pages/public/eventos/revival-2k26.vue'),
    meta: { public: true, raw: true }
  },
  {
    path: '/midia-experience',
    name: 'EventoMidiaExperience',
    component: () => import('./pages/public/eventos/midia-experience.vue'),
    meta: { public: true, raw: true }
  },
  {
    path: '/legitima-identidade',
    name: 'EventoLegitimaIdentidade',
    component: () => import('./pages/public/eventos/legitima-identidade.vue'),
    meta: { public: true, raw: true }
  },
  {
    path: '/acamp-jovem-2k27',
    name: 'EventoAcampJovem2k27',
    component: () => import('./pages/public/eventos/acamp-jovem-2k27.vue'),
    meta: { public: true, raw: true }
  },
  {
    path: '/scan',
    name: 'Scan',
    component: ScanPage,
    meta: { public: true }
  },
  {
    path: '/inscricao/:inscricaoId/qr',
    name: 'MeuQr',
    component: MeuQrPage,
    meta: { public: true }
  },
  {
    path: '/',
    component: PublicLayout,
    children: [
      { path: '', name: 'PublicHome', component: NotFoundPage, meta: { public: true } },
      { path: 'checkout/:inscricaoId', name: 'Checkout', component: CheckoutPage, meta: { public: true } },
      { path: 'sucesso/:inscricaoId', name: 'Sucesso', component: SucessoPage, meta: { public: true } },
      { path: ':slug', name: 'Evento', component: EventoPage, meta: { public: true } }
    ]
  }
]

const router = createRouter({ history: createWebHistory(), routes })

router.beforeEach((to, from, next) => {
  if (to.meta.public) return next()
  if (!isAuthenticated()) return next('/admin/login')
  if (Array.isArray(to.meta.roles) && to.meta.roles.length > 0) {
    const role = getAdminRole()
    if (!role || !to.meta.roles.includes(role)) return next('/admin')
  }
  next()
})

const pinia = createPinia()
const app = createApp(App)

app.provide('pusher', pusher)
app.use(pinia).use(router).use(VueToast)
app.mount('#app')
